import React, { useEffect, useState } from "react";
import "./Login.scss";

import { connect } from "react-redux";
import { LoginUser } from "../../ts/Auth";

import ReduxState from "../../ts/Redux";
import Button from "../ui/Button/Button";
import Input from "../ui/Input/Input";
import { Errors } from "../../ts/Errors";
import { useDispatch, useSelector } from "../../redux/store";
import { useNavigate } from "react-router";
import { useQueryWithPopupErrorHandling } from "../../providers/utils/hooks";
import { SET_ERRORS } from "../../redux/actions/errorActions";
import { ErrorKey, serverErrorOfKey } from "../../types/server-api/errors";
import { LOGIN_USER } from "../../redux/actions/authActions";

interface Props {}

const Login: React.FC<Props> = ({}: Props) => {
  const auth = useSelector((state) => state.auth);
  const errors = useSelector((state) => state.errors);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { call } = useQueryWithPopupErrorHandling();

  useEffect(() => {
    if (auth.logged && !auth.isLoading) {
      navigate("/");
    }
  }, [auth.logged, auth.isLoading]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setLoading(true);
    call(
      () => LOGIN_USER({ name: email, password: password }),
      "Prihlášenie nebolo úspešné",
      null,
      (user) => {
        dispatch(user);
        navigate("/");
      },
      (serverErrors) => {
        const errors: Errors = {};

        if (!email) {
          errors.email = "Zadejte přihlašovací jméno";
        }

        if (
          serverErrorOfKey(ErrorKey.ADMIN_INVALID_LOGIN, serverErrors) ||
          serverErrorOfKey(ErrorKey.ADMIN_INVALID_AUTH, serverErrors)
        ) {
          errors.email = "Neplatné přihlašovací údaje";
        }

        if (!password) {
          errors.password = "Zadejte heslo";
        }

        dispatch(SET_ERRORS(errors));
      }
    );
    setLoading(false);
  };

  return (
    <div className="login">
      <div>
        <div className="title">VITAJTE!</div>
        <div className="subtitle">PRIHLASOVACIE ÚDAJE</div>
        <div className="login-form">
          <div>
            <Input
              error={errors.email}
              placeholder="Váš email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <Input
              type="password"
              error={errors.password}
              placeholder="Heslo"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <Button
              style={{
                width: 220,
              }}
              loading={loading}
              onClick={() => {
                setLoading(true);
                onSubmit();
              }}
            >
              PRIHLÁSIŤ SA
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
